import React, { useState } from 'react';
import ChatMenuComponent from './ChatMenuComponent';
import ChatFloatingButton from './ChatFloatingButton';

function ChatComponent({ floatChatIcon = true }) {
  const [isOpenModal, setIsOpenModal] = useState(false);

  const handleChatWindowButton = () => {
    if (!isOpenModal) {
      setIsOpenModal(true);
    } else {
      setIsOpenModal(false);
    }
  };

  return (
    <>
      <ChatMenuComponent
        isOpen={isOpenModal}
        windowHandler={handleChatWindowButton}
      />

      {floatChatIcon ? (
        <ChatFloatingButton
          windowHandler={handleChatWindowButton}
          windowState={isOpenModal}
        />
      ) : (
        ''
      )}
    </>
  );
}

export default ChatComponent;
